/* eslint-disable jsx-a11y/label-has-associated-control */
import React, { useContext, useEffect } from 'react';
import Card from 'react-bootstrap/Card';
import moment from 'moment';
import { shortenStringWithTooltip } from '../../helper';
import ModalContext from '../../DamPreviewModal/ModalContext';
import DamPreviewModal from '../../DamPreviewModal';
import noImage from '../../../assets/images/no-image.png';
import ImageLazyLoader from '../../ImageLazyLoader';

function DamFolderFileCard({ t, item, ind, allSelectedFolderFiles, onSelectCheckBox, isPageDisable, onDelete }) {
  const { isModalOpen, openModal, setDamFileid, closeModal, setModalData } = useContext(ModalContext);

  const getFullName = (obj) => {
    return obj.name || `${obj?.firstName} ${obj?.lastName}`;
  };
  useEffect(() => {
    return () => {
      closeModal(false);
      setModalData(null);
    };
  }, []);
  return (
    <>
      <div id="accordion" className="col-lg-3 dam-card-container item-list">
        <Card className="listing-card">
          <Card.Header>
            <div>
              <ul className="card-header-icon">
                <li>
                  <div className="cus-chk-block">
                    <input
                      name={`dam_check_${ind}`}
                      id={`dam_check_${ind}`}
                      type="checkbox"
                      checked={allSelectedFolderFiles?.includes(item?._id)}
                      onChange={() => onSelectCheckBox(item?._id)}
                      disabled={isPageDisable}
                    />
                    <label htmlFor={`dam_check_${ind}`} className="cus-chklabel" />
                  </div>
                </li>
                <li>
                  <button type="submit" className="btn p-0" aria-label="Delete" title="Delete" onClick={() => onDelete(item?._id)} disabled={isPageDisable}>
                    <i className="icon-new-unlink f-14" />
                  </button>
                </li>
                <li>
                  <div className="info-container xs-position-bottom d-flex text-left">
                    <span className="icon-info f-18" />
                    <div className="info-content">
                      <p className="mb-0">
                        <b>{t('COLOR_WAY_CARD.CREATED_BY_DATE_TIME')}&nbsp;</b>
                        <span>{`${typeof item?.createdBy === 'object' ? getFullName(item?.createdBy) : item?.createdBy} ${
                          item?.createdAt && moment(item?.createdAt).format('DD-MMMM-YYYY, HH:mm:ss a')
                        }`}</span>
                      </p>
                      <p className="mb-0">
                        <b>{t('COLOR_WAY_CARD.MODIFIED_BY_DATE_TIME')}&nbsp;</b>
                        <span>{`${typeof item?.modifiedBy === 'object' ? getFullName(item?.modifiedBy) : item?.modifiedBy} ${
                          item?.updatedAt && moment(item?.updatedAt).format('DD-MMMM-YYYY, HH:mm:ss a')
                        }`}</span>
                      </p>
                    </div>
                  </div>
                </li>
              </ul>
            </div>
          </Card.Header>
          <Card.Body
            onClick={() => {
              openModal();
              setDamFileid(item?._id);
            }}
          >
            <div className="p-2">
              <ImageLazyLoader
                height={200}
                src={item?.croppedImage || item?.imageUrl || item?.imageLink || item?.videoThumbnail || noImage} // use normal <img> attributes as props
              />
            </div>
            <p className="font-weight-bold py-2 mb-0">{item?.assetTitle ? shortenStringWithTooltip(item.assetTitle, 15) : ''}</p>
          </Card.Body>
        </Card>
      </div>
      {isModalOpen && <DamPreviewModal />}
    </>
  );
}

export default DamFolderFileCard;
